import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { closePage } from '@h5-journey/bridge'
import { px2vw, useStatusBarHeight } from '@h5-journey/utils'

interface Props {
  /** 标题 */
  title?: string
  /** 是否固定在顶部 */
  fixed?: boolean
  /** 左侧文字 */
  leftText?: string
  /** 右侧文字 */
  rightText?: string
  /** 自定义左侧点击事件 */
  onClickLeft?: () => void
  /** 自定义右侧点击事件 */
  onClickRight?: () => void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  props: {
    title: { default: '' },
    fixed: { type: Boolean, default: true },
    leftText: { default: '' },
    rightText: { default: '' },
    onClickLeft: {},
    onClickRight: {}
  },
  setup(__props: any) {

const props = __props

const router = useRouter()
const { statusBarHeight } = useStatusBarHeight()

const navBarStyle = computed(() => {
  return {
    paddingTop: props.fixed ? px2vw(statusBarHeight.value) : '0px'
  }
})

const handleClickLeft = () => {
  if (props.onClickLeft) {
    props.onClickLeft()
    return
  }
  if (router.options.history.state.back) {
    router.back()
  } else if (window.history.length > 1) {
    window.history.back()
  } else {
    closePage()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createBlock(_component_van_nav_bar, {
    fixed: _ctx.fixed,
    "z-index": 3000,
    class: "app-nav-bar",
    style: _normalizeStyle(navBarStyle.value),
    title: _ctx.$slots.title ? '' : _ctx.title,
    "left-text": _ctx.leftText,
    "right-text": _ctx.rightText,
    onClickLeft: handleClickLeft,
    onClickRight: _ctx.onClickRight
  }, _createSlots({
    left: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", {
          d: "M15 18L9 12L15 6",
          stroke: "#333333",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1))
    ]),
    _: 2
  }, [
    (_ctx.$slots.title)
      ? {
          name: "title",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "title", {}, undefined, true)
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots.right)
      ? {
          name: "right",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "right", {}, undefined, true)
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["fixed", "style", "title", "left-text", "right-text", "onClickRight"]))
}
}

})